import React, { Component } from 'react';
import Tooltip from '../../components/UI/TooltipIcon/TooptipIcon';
import orderBy from 'lodash/orderBy';
import {withRouter} from 'react-router-dom';
import moment from 'moment';
import { Modal, ModalBody, Button, Dropdown, DropdownToggle, DropdownMenu, Popover, PopoverHeader, PopoverBody, Row, Col } from 'reactstrap';
import { connect } from 'react-redux';
import reply from '../../assets/stories/reply.svg'
import Select from 'react-select';
import 'rc-checkbox/assets/index.css';
import {checkValidityForAnonymousToggleEdit, profilePicValidityCheck, storyReactions} from '../../utils/constants'
import UserIcon4 from '../../assets/user-image-plc/User_Icon_4.svg';

import { MentionsInput, Mention } from 'react-mentions'
import './Stories.css';
import Loading from '../../hoc/Loading/Loading';
import Reactions from './Reactions.jsx'
import StoryCommentList from './StoryCommentList.jsx'
import defaultStyle from './defaultStyle';
import defaultMobileStyle from './defaultMobileStyle';
import defaultMentionStyle from './defaultMentionStyle'
import classNames from './Stories.css'
import Toggle from "react-toggle";
import axios from '../../axios';
import * as url from '../../utils/url';
import * as actionCreators from '../../modules/actions/index';
import { ListGroup, ListGroupItem } from 'reactstrap';
import avatarIcon from '../../assets/default-avatar.png';
import ShowMore from 'react-show-more';
import PlaceholderStories from './PlaceholderStories';
import If from '../../components/Shared/If';
import classnames from 'classnames';
import get from 'lodash/get';
import filter from 'lodash/filter';
import { isMobile } from '../../utils/deviceInfo';

class StoryItems extends Component {
  constructor(props) {
    super(props);
    const hideAnonymous = props.user.profile && props.user.profile.organizationId.disableAnonymity ? checkValidityForAnonymousToggleEdit(
      props.item.createdOn,
      props.item.isAnonymous,
      "cultureApp",
      props.user.profile.organizationId.disableAnonymity
    ) : false

    this.state = {
      stories: [],
      archievedStories: [],
      privacy: "PUBLIC",
      isAnonymous: false,
      isAnonymousVisible: !hideAnonymous,
      disableSubmit: true,
      showReplies:false,
      mentionsSelected:[],
      mentionsFound:[],
      showResponses:[],
      isCommentsOpen:null,
      responseCounter:this.props.item.storyCounter,
      disableSubmit: true,
      showUserReactions:false,
      showReactions:null,
      reactionCounter: this.props.item.reactionArr && this.props.item.reactionArr.reactions &&this.props.item.reactionArr.reactions.length>0?this.props.item.reactionArr.reactions.length:0,
      reactionList: this.props.item.reactionArr && this.props.item.reactionArr.reactions &&this.props.item.reactionArr.reactions.length>0?this.props.item.reactionArr.reactions.slice(0,3):[],
      userReacted: this.props.item.reactionArr && this.props.item.reactionArr.reactions &&this.props.item.reactionArr.reactions.length>0?this.props.item.reactionArr.reactions.filter(e=>{
        return e.userId === this.props.user.profile._id
      }) : "null",
      // mentionsFound:[
      //   {display: "Chakradar Raju", id: "Chakradar"},
      //   {display: "Chakradar Raju", id: "Chakradar"},
      //   {display: "Arun Verma", id: "Arun"},
      //   {display: "Pradeep Jagdish", id: "Pradeep"},
      //   {display: "Sajjan Kumar Jain", id: "Sajjan"},
      //   {display: "sajjan", id: "sajjan"},
      //   {display: "Srikar Yekollu", id: "Srikar"},
      //   {display: "Shruti Kapoor", id: "Shruti"},
      //   {display: "s", id: "s"},
      //   {display: "String test", id: "String"},
      //   {display: "Muralidharan Venkatasubramanian", id: "Muralidharan"}
      // ],
      mentionWord:"",
      userReactions:[],
      description: {
        value: "",
        error: false
      },
      response:"",
      mentionBool:false,
      mentionsIndex:0,
      dropdownOpen: false,
      title: "",
      showCreateStoryModal: false,
      modalActionType: "Create",
      categoryDefinitionPopoverOpen: false,
      collapseCompleted: true,
      showRemoveFeedConfirmationModal: false,
      storyIdRemove: ''
    }
  }




  toggleDropdown = (id) => {
    let { dropdownOpen } = this.state;
    if (dropdownOpen === id) {
      this.setState({ dropdownOpen: "" });
    } else {
      this.setState({ dropdownOpen: id });
    }
  }



  handleCreateStoryResponse = () => {
    const { description, isAnonymous, privacy, title, mentionsSelected } = this.state;
    const { item } = this.props
    let dValue = description.value.replace(/<\/?![^>]+(>|$)/g, "").replace(/[\. ,:-]+/g, "")
    let isUrl;
    if(dValue.length>0){


    let desc = `<span> ${description.value.replace(/<\/?![^>]+(>|$)/g, "")} </span>`
    let sanitizedDescription={}
    let mentionsText =  `<span>${description.value.replace(/<\/?![^>]+(>|$)/g, "")}</span>`
    sanitizedDescription.value = `${description.value.replace(/<\/?![^>]+(>|$)/g, "")}`
    sanitizedDescription.userReferences=[]
    // console.log(desc, '----mselect--->' ,mentionsSelected)
    let isMention = false

    let desArr = desc.split(" ")

    let mArray = desArr.filter(e=> {
      if(e.indexOf("@")>-1){
        return e
      }
    })
    // console.log(desc, '--desArr---', desArr,'----marr---', mArray)

    // console.log('----',mArray)
    let mentions = mentionsSelected.filter(e=>{
      let valMention = `({ "_id": "${e._id}", "email": "${e.email}", "name": "${e.name}"})`
      // console.log("---vMention ----", valMention)
      // let wLength = word.length
      if(desc.includes(valMention)){
        // console.log(e, '---w----',word)
        let strReplace = `@[@${e.name}]({ "_id": "${e._id}", "email": "${e.email}", "name": "${e.name}"})`
        // console.log(strReplace)
       desc = desc.replace(strReplace, `<a class="userMentionWord" href="/home/${this.props.user.profile.organizationId._id}/profile/${e._id}">@${e.name}</a>`)

       sanitizedDescription.value= sanitizedDescription.value.replace(strReplace, `@${e.name}`)
       sanitizedDescription.userReferences.push(e._id)
       isMention=true;
      // console.log(desc)
        return e
      }
    })

    let splitDesc = desc.split(" ").map(e=>{
      let val=e
      if(e.indexOf('http')>-1 && e.indexOf('www')==-1){
        isUrl=true
        val=e.replace(/((http|https)?:\/\/[^\s]+)/g,`<a class="urlLink" href='$1' target='_blank' >$1</a>`)
      } else if(e.indexOf('www')>-1 && e.indexOf('http')==-1){
        isUrl=true
         val=e.replace(/(www[^\s]+)/g,`<a class="urlLink" href='${'https:\/\/'}$1' target='_blank' >$1</a>`)
     }else if(e.indexOf('www')>-1 && e.indexOf('http')>-1){
      isUrl=true
       val=e.replace(/((http|https)[^\s]+)/g,`<a class="urlLink" href='$1' target='_blank' >$1</a>`)
     }
     return val
    })

    desc = splitDesc.join(" ")


    if (desc.length > 0) {
      let payload = { description: desc, title, isAnonymous, privacy };
      if (isAnonymous) {
        payload.isAnonymous = isAnonymous
      } else if (isAnonymous === undefined) {
        payload.isAnonymous = false
      }
      if(mentions && mentions.length>0){
        payload.users = mentions
      }
      payload.parent=item._id
      payload.isMention = isMention
      payload.sanitizedDescription = sanitizedDescription
      payload.mentionsText = mentionsText
      // console.log(payload)
      // return

      axios.post(url.createStoryResponse(item._id), payload).then(({ data }) => {
        this.setState((prevState) =>({
          description: "",
          title: "",
          privacy: true,
          isAnonymous: false,
          mentionsSelected: [],
          mentionsFound: [],
          mentionWord:"",
          showReplies:false,
          isCommentsOpen:true,
          responseCounter: prevState.responseCounter +1
        }));
        this.showStoryComments(item._id)
      })


      this.setState({ showCreateStoryModal: false, description: "", title: "", privacy: true })
    } else {
      this.setState({ showCreateStoryModal: true });
    }

    }

  }

  handleChangeStoryDescription = (event) => {
    let descriptionContext = event.target.value;
    // let descriptionContext = event.editor.getData();
    // console.log(descriptionContext)
    // console.log(this.state.description.value)
    let word, value

    let {mentionsFound, mentionWord}=this.state
    if(descriptionContext===""){
      word= []
      value=""
    } else {
      word = mentionsFound
      value =mentionWord
    }
    let valCheck= event.target.value.replace(/<\/?![^>]+(>|$)/g, "").replace(/[\. ,:-]+/g, "").replace(/^\n|\n$/g, '');

    this.setState({ description: { value: descriptionContext }, mentionWord:value, mentionsFound:word,disableSubmit: valCheck.length === 0 })
  }

  selectUserMention = (val) => {
    // console.log(val)
    // console.log(val.toString(), typeof val, JSON.parse(val))
    let obj = JSON.parse(val)
    // console.log(obj)
    this.setState(prevState => ({
      mentionsFound:[],
      mentionWord:"",
      // description: {value: text},
      mentionsSelected: [...prevState.mentionsSelected, obj]
    }))

  }


  fetchUsers = (query,callback)=> {
    let users;
    // console.log(query)
    if (!query) return
    axios.get(url.findUser(query)).then((resp,idx) =>
      resp.data.data.map(user => ({
        display: "@"+user.firstName + " " + user.lastName,
        id:`{ "_id": "${user._id}", "email": "${user.email}", "name": "${user.firstName + " " + user.lastName}"}`
        // {_id:user._id, email: user.email, idx},
        // name: user.firstName + " " + user.lastName,
        // _id: user._id,
        // email: user.email,
      }))
    ).then(callback)
  }

  handlePermissionChange = changeEvent => {
    this.setState({
      isAnonymous: changeEvent.target.checked
    });
  }

  archiveStory = (id, actionType) => {
    actionType === 'Archive' ?
      this.deleteStory(id) :
      this.deArchiveStory(id);
    this.toggleDropdown(id);
  }

  deleteStory = (id) => {
    axios.put(url.archiveStory(id)).then(data => {
      this.props.getStoryFeeds();
      this.setState({
        dropdownOpen: false
      });
    });
  }

  deArchiveStory = (id) => {
    axios.put(url.deArchiveStory(id)).then(data => {
      this.props.getStoryFeeds();
      const result = data;
      this.setState({
        dropdownOpen: false
      });
    });
  }

  removeStoryConfirmation=()=>{
    let {storyIdRemove}=this.state
    // console.log("storyu -- ", storyIdRemove)
    this.setState({ showRemoveFeedConfirmationModal : false });
    axios.put(url.removeStoryFeeds(storyIdRemove)).then(resp => {
      this.setState({
        dropdownOpen: false
      });

      if(resp.data.data.parentStory && resp.data.data.parentStory.item && resp.data.data.type==="storyResponse"){
        this.setState((prevState) => ({
          responseCounter: prevState.responseCounter-1
        }))
        this.showStoryComments(resp.data.data.parentStory.item)
      } else {
        this.props.getStoryFeeds(this.props.user);
      }
    });
  }


  showStoryRemoveConfirmation = (storyId) => {
    // console.log("storyu -- ", storyId)
    // this.props.showStoryRemoveConfirmation(storyId)
    // console.log(this.props)
    // console.log(storyId)
    this.setState({
      showRemoveFeedConfirmationModal : !this.state.showRemoveFeedConfirmationModal,
      storyIdRemove : storyId
    });
  }


  closeStoryRemoveConfirmation = (storyId) => {
    this.setState({
      showRemoveFeedConfirmationModal : false,
      storyIdRemove : ''
    });
  }

  createMarkup = (input) => {
    // console.log(input)
    return { __html: `<div>${input}</div>` };
  }

  createResponse=()=>{
    this.setState((prevState) => ({
      showReplies : !prevState.showReplies,
      showReactions:false,
    }));
  }


  showStoryComments =(item)=>{
    // console.log(item)
    this.setState({showReactions:false})
    if(this.state.isCommentsOpen!==false){
      axios.get(url.getStoryComments(item)).then(({ data }) => {
        // console.log(data)
        let arr = data.data.storyList
        this.setState((prevState) => ({
          showResponses: [...arr],
          isCommentsOpen: false
        }));
      });
    } else {
       this.setState((prevState)=>({
        isCommentsOpen: true,
       }))
    }
  }

  navigateLink = (e) =>{
    e.preventDefault()
    let className= e.target.className
    if(className!=="urlLink"){
      let idx= e.target.href.indexOf('home')-1
      let link = e.target.href.slice(idx)
      this.props.history.push(link);
    }

  }


  addReaction = (val) => {
    let { item, user } = this.props;
    let {reactionList, userReactions, reactionCounter}=this.state
    // console.log(reactionCounter)
    // console.log(val)
    // console.log(user)
    let payload={
      userId: user.profile._id,
      reaction: val,
      _id:val,
      user:user.profile,
      createdOn: Date.now,
      storyId:item._id,
      storyOwner:item.userId,
      orgId:user.profile.organizationId._id,
    }

    // if(this.state.reactionList.indexOf(payload.userId)>-1)
    let rList = reactionList
    let uR = userReactions
    let isReactionListModified = false
    let isUserListModified = false


    rList.map(e=>{
      if(e.userId===payload.userId){
        e.reaction = payload.reaction
        isReactionListModified=true
      }
    })

    uR.map(e=>{
      if(e.user._id===payload.userId){
        e.reaction = val
        e._id = val
        e.user.firstName=payload.user.firstName?payload.user.firstName:""
        e.user.lastName=payload.user.lastName?payload.user.lastName:""
        e.user.profilePic= profilePicValidityCheck(payload.user.profilePic)?payload.user.profilePic:""
        isUserListModified=true
      }
    })

    if(isReactionListModified){
      this.setState((prevState) => ({
        reactionList : [...rList],
      }));
    } else{
      if(reactionList.length<3){
        this.setState((prevState) => ({
          reactionList : [ {reaction:val, userId: user.profile._id},...prevState.reactionList],
          reactionCounter: prevState.reactionCounter+1
        }));
      }else {
        this.setState((prevState) => ({
          reactionCounter: prevState.reactionCounter+1
        }));
      }

    }

    if(isUserListModified){
      this.setState((prevState) => ({
        userReactions: [...uR]
      }));
    } else{
      this.setState((prevState) => ({
        userReactions: [payload,...prevState.userReactions]
      }));
    }

    axios.post(url.addReaction(item._id), payload).then(({ data }) => {
      // console.log(data)

    })

  }

  pickImage=(val)=>{
    let selected = storyReactions.filter(x=> x._id===val)[0]
    return selected.image
  }


  showReactionList = ()=>{
    const { item } = this.props;
    axios.get(url.userReactions(item._id)).then(({ data }) => {
      // console.log(data.data, this.state.userReactions)
      let value = data.data
      if(value.storyList && value.storyList.length>0){
        this.setState((prevState) =>({
          showUserReactions:true,
          userReactions: [...value.storyList]
        }));
      } else if(this.state.userReactions.length>0) {
        this.setState((prevState) =>({
          showUserReactions:true,
          userReactions: [...prevState.userReactions]
        }));
      }


    })


  }

  removeReactionHover = ( )=>{
    // console.log('counter---', this.state.reactionCounter)
    this.setState( prevState=> ({
      showReactions:false,
    }))
  }

  closeReactionModal =()=>{
    this.setState({showUserReactions:false})
  }

  removeReaction = ()=>{
    // console.log("remove reaction")
    let userId = this.props.user.profile._id
    let storyId = this.props.item._id
    let userRlist = this.state.userReacted
    let reactionList = this.state.reactionList
    // console.log(userRlist, this.props.user.profile, reactionList)

    if(userRlist.length>0){
      let ulist = userRlist.filter(e=>e.userId!=this.props.user.profile._id)
      // console.log(ulist)
      this.setState({userReacted:[...ulist]})
    }

    if(reactionList.length>0){
      let rlist = reactionList.filter(e=>e.userId!=this.props.user.profile._id)
      // console.log(rlist)
      this.setState( prevState=>({
        reactionList:[...rlist],
        reactionCounter: prevState.reactionCounter-1

      }))
    }

    axios.delete(url.deleteReaction(storyId,userId)).then(({data}) => {
      // console.log(data)
    });
  }


  showTopicName =(topic)=>{
    let {filters} = this.props;
    let res = filters.filter(e=>e._id===topic._id)
    return res[0].name
  }

  editStory = (story)=> {
    // console.log(story)
    this.props.showCreateStory()
  }

  renderStories = () => {
    const isAdmin = this.props.user.profile.role === 'Admin' || this.props.user.profile.role === 'SuperAdmin';
    const list = orderBy(this.state.stories, "createdOn", "desc");
    const { orgAdmin } = this.props.user.profile;
    const { item, actionType, avatar } = this.props;
    let {isCommentsOpen, description, showUserReactions,isAnonymous, disableSubmit, reactionList, showResponses, responseCounter}=this.state
    const createStoryModalStyle = classnames('addStoryComment btn btn-primary', {
      'disabled': disableSubmit,
    });
    // console.log(this.props.item)
    return (
        <ListGroupItem className="ml-3" key={item._id} >
          <div className="avatar">
            <img src={item.isAnonymous? avatarIcon: item.profilePic?item.profilePic: avatarIcon} className="avatar-pic" alt="" />
            <span className="storyOwner">
              <span className="storyUsername">
              {item.isAnonymous ? 'Anonymous user' : this.props.user.profile._id === item.userId ? 'me' : item.fullname} <br/>
              </span>
                <span className="storyDate">{moment(item.createdOn).format("MMM D, YYYY")}</span>
              </span>

          </div>

          <div className="story-list col-xs-12" /* onClick={(e)=> this.navigateLink(e)} */>

            <span dangerouslySetInnerHTML={this.createMarkup(item.description.replace(/\n/g,"<br />"))}></span>
          </div>
        <div className="reactionsHover">

        <Reactions removeReaction={this.removeReaction} saveReaction={this.addReaction} hideReactions = {this.state.showReactions} userReacted={this.state.userReacted}/>

        {/* <div onMouseLeave={this.removeReactionHover}>
          <Reactions saveReaction={this.addReaction} hideReactions = {this.state.showReactions}/>
        </div> */}

        <div className="replyStory" onClick={this.createResponse}>
          <img src={reply}/>
          Comment
        </div>

        {item.topics && item.topics.length>0?
        item.topics.map( (topic, idx) =>{
          return(
            <div className="storyTopics" key={idx}>
            {this.showTopicName(topic)}
           </div>
          )

        })

          :
          null
        }






        </div>


            <Dropdown isOpen={this.state.dropdownOpen === item._id ? true : false}
                toggle={() => this.toggleDropdown(item._id)} className="wwDropdown">

                <If condition={orgAdmin || this.props.user.profile._id === item.userId}>
                  <DropdownToggle
                    tag="span"
                    className="chart-item-menu"
                    onClick={() => this.toggleDropdown(item._id)}
                    data-toggle="dropdown"
                    aria-expanded={this.state.dropdownOpen === item._id ? true : false}
                  >
                    <i className="chart-item-menu flaticon-menu-1" style={{ cursor: 'pointer' }}></i>
                  </DropdownToggle>
                </If>

                <If condition={orgAdmin || this.props.user.profile._id === item.userId}>
                  <DropdownMenu right className="chart-dropdown" style={{ padding: '0' }}>
                    <div>
                    {/* <If condition={ this.props.user.profile._id === item.userId}>
                        <div className="chart-list-dropdown-options"
                          style={{ display: 'flex' }}
                          onClick={() => this.editStory(item)}
                          >

                          <i className="chart-item-menu flaticon-edit"></i>
                            <span  className="chart-list-dropdown-options-text">
                              Edit
                            </span>
                        </div>
                      </If> */}

                      <If condition={orgAdmin || this.props.user.profile._id === item.userId}>
                        <div className="chart-list-dropdown-options"
                          style={{ display: 'flex' }}
                          onClick={() => this.showStoryRemoveConfirmation(item._id)}
                          >

                          <i className="chart-item-menu flaticon-minus"></i>
                            <span  className="chart-list-dropdown-options-text">
                              Remove from Feed
                            </span>
                        </div>
                      </If>

                      <If condition={this.props.user.profile._id === item.userId}>
                        <div className="chart-list-dropdown-options"
                          style={{ display: 'flex' }}
                          onClick={() => this.archiveStory(item._id, actionType)}>
                          <If condition={actionType === 'Restore'}>
                            <i className="chart-item-menu flaticon-update"></i>
                          </If>
                          <If condition={actionType === 'Archive'}>
                            <i className="chart-item-menu flaticon-trash"></i>
                          </If>
                          <span className="chart-list-dropdown-options-text">{actionType}</span>
                        </div>
                      </If>

                    </div>
                  </DropdownMenu>
                </If>
              </Dropdown>
              <div className="storyOptionsContainer" >
                {/* <span className="replyButton" onClick={this.createResponse}>Reply</span> */}

                {this.state.reactionList && this.state.reactionList.length>0?
                <div onClick={this.showReactionList} className="reactionsContainer">
                {/* <span className="viewReactions">View</span>  */}
                  {this.state.reactionList.map((e,idx)=> {
                  return (
                      <img className="reactionItems" src={this.pickImage(e.reaction)} key={idx}/>
                  )

                })}
                <span className="reactionCounter">
                ({this.state.reactionCounter})
                </span>
                </div>

                :
                "No Reactions"}
                <span> | </span>
                {/* <span className="viewComments" onClick={(e) => this.showStoryComments(this.props.item._id)}>
                   View Replies  ({responseCounter})
                   </span> */}
                  {responseCounter >0 ?
                  <span className="viewComments" onClick={(e) => this.showStoryComments(this.props.item._id)}>
                   View Replies  ({responseCounter})
                   </span>
                  :
                  <span className="" >
                  No replies
                  </span>

                  }
              </div>


              {this.state.showUserReactions?
                <Modal isOpen={this.state.showUserReactions} className="archive-modal show-user-reactions">
                <ModalBody>
                  <div className="modal-title reactionListTitle">
                  {this.state.userReactions.length} Reactions
                  </div>
                  <div className="modal-content-wrapper word-break reactionModal">
                    {this.state.userReactions && this.state.userReactions.length>0?
                      this.state.userReactions.map( (e,idx)=>{
                        return (
                          <div className="userReactionContainer" key={idx}>
                            <div>
                            <img className="userReactionPic" src={e.user.profilePic || UserIcon4}/>
                            <span className="userReactionName">
                              {e.user.firstName} {e.user.lastName}
                            </span>
                            </div>
                            <img className="reactionModalImage" src={this.pickImage(e._id)}/>
                          </div>
                        )
                      })
                    :
                    null
                    }
                  </div>
                  <Row className={`mt30 ${isMobile && 'reaction-close'}`} style={{marginLeft:'9px'}}>
                    <Col sm={{ size: 4 }} md={{ size: 4 }}>
                      <Button className="archive-button" onClick={this.closeReactionModal}>Close</Button>{' '}
                    </Col>
                    {/* <Col sm={{ size: 4 }} md={{ size: 4 }}>
                      <Button className="cancel-button float-right" onClick={this.closeReactionModal}>
                          Cancel
                      </Button>
                    </Col> */}
                  </Row>
                </ModalBody>
              </Modal>
              :
              null
              }


              {this.state.showReplies?
                <div className="mentionsReplyInput">
                  <MentionsInput placeholder="Click here and begin typing your story" singleLine={false} style={isMobile ? defaultMobileStyle : defaultStyle} value={description.value} onChange={this.handleChangeStoryDescription}>
                    <Mention
                      trigger="@"
                      style={defaultMentionStyle}
                      data={ this.fetchUsers }
                      onAdd={ this.selectUserMention }
                    />
                  </MentionsInput>

                  {/* <button className="addStoryComment btn btn-primary" onClick={this.handleCreateStoryResponse}> Post </button> */}
                  <Button className={createStoryModalStyle}
                    onClick={this.handleCreateStoryResponse}>
                    <span className="profile-modal-save-btn-txt"> Reply
                      <span className="ml10 flaticon-tick"></span>
                    </span>
                  </Button>
                  <div className="anonymousStoryResponse" hidden={!this.state.isAnonymousVisible} >
                      <span className="ml10">
                        <Toggle
                          checked={isAnonymous}
                          icons={false}
                          onChange={this.handlePermissionChange}
                        />
                      </span>
                      <span className="permission-value ml10">Anonymous</span>
                    </div>
                </div>
              :
              null
              }

             {showResponses && showResponses.length>0?
             <div className= {isCommentsOpen===false?"storyItemsContainer":""}>
                  {showResponses.map( e=> {
                  if(e.isDeleted!==true){
                    const avatar = e.isAnonymous ? avatarIcon : e.profilePic || avatarIcon;
                    return(
                      <div key={e._id}>
                        <StoryCommentList orgAdmin={orgAdmin} user={this.props.user} isCommentsOpen={isCommentsOpen} showStoryComments={this.showStoryComments} removeCommentConfirmation={this.showStoryRemoveConfirmation} key={e._id} actionType={this.props.actionType} item={e} avatar={avatar}/>
                      </div>
                    )
                  }
                })}
             </div>

                :
                null
              }
            </ListGroupItem>
          );
  };



  getStoriesCount = () => {
    const filteredStories = this.state.stories.filter((story) => !story.isDeleted);
    return filteredStories.length
  }

  handleCollapse = () => {
    this.setState((state) => ({ collapseCompleted: !state.collapseCompleted }));
  }



  render() {
    const { description, isAnonymous, disableSubmit, stories, collapseCompleted, categoryDefinitionPopoverOpen, archievedStories, showRemoveFeedConfirmationModal } = this.state;
    const createStoryModalStyle = classnames('addStoryComment btn btn-primary', {
      'disabled': disableSubmit,
    });
    // console.log(this.state.reactionCounter)

    return (
      <div className="stories" onMouseLeave={this.removeReactionHover}>
       {this.renderStories()}

       <Modal isOpen={showRemoveFeedConfirmationModal} className="archive-modal remove-story-model">
          <ModalBody>
            <div className="modal-title">
              Remove Post
              <span className="model-close" onClick={this.closeStoryRemoveConfirmation}>
                <i className="flaticon-close"></i>
              </span>
            </div>
            <div className="modal-content-wrapper word-break">
            You are about to Remove post. This action is irreversible and will completely delete the post. <br />
              No one, including the author of the post, will be able to see it any more.
            </div>
            <Row className="mt30 remove-story-buttons" style={{marginLeft:'9px'}}>
              <Col sm={{ size: 4 }} md={{ size: 4 }}>
                <Button className="archive-button" onClick={this.removeStoryConfirmation}>Remove Post</Button>{' '}
              </Col>
              <If condition={!isMobile}>
                <Col sm={{ size: 4 }} md={{ size: 4 }}>
                  <Button className="cancel-button float-right" onClick={this.closeStoryRemoveConfirmation}>
                      Cancel
                  </Button>
                </Col>
              </If>
            </Row>
          </ModalBody>
        </Modal>


      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: (data) => dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) => dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(StoryItems, axios)));
